/**
 * Created by filatov on 15.09.2015.
 */
import LeaveCSVPreviewColumnsStrategy from './LeaveCSVPreviewColumnsStrategy'
import LeaveCSVPreviewBalanceColumnsRender from './LeaveCSVPreviewBalanceColumnsRender'

export default function LeaveCSVPreviewBalancesOnlyStrategy() {}

LeaveCSVPreviewBalancesOnlyStrategy.prototype = new LeaveCSVPreviewColumnsStrategy();

LeaveCSVPreviewBalancesOnlyStrategy.prototype.init = function ( balanceQualifier )
{
    LeaveCSVPreviewColumnsStrategy.prototype.init.call( this );

    this.balanceColumnsRender = new LeaveCSVPreviewBalanceColumnsRender().init(balanceQualifier);
    return this;
};

LeaveCSVPreviewBalancesOnlyStrategy.prototype.getNumOfDataColumns = function ()
{
    return this.balanceColumnsRender.getNumberOfDataBalancesCells();
};

LeaveCSVPreviewBalancesOnlyStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.balanceColumnsRender.addHeaderBalancesCells(mainHeaderRow);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/leave/LeaveCSVPreviewBalancesOnlyStrategy.js